/**
 * Shared primitives — ISO timestamps, UUIDs, workspace category enum.
 *
 * The v1 type catalogues used plain ``string`` everywhere; v2 keeps the
 * wire shape identical (snake_case JSON) but parses through zod at the
 * boundary so a malformed BE response surfaces immediately instead of
 * silently corrupting Zustand state.
 */

import { z } from "zod";

/** ISO-8601 timestamp string, e.g. ``2026-05-17T12:34:56.789Z``. */
export const IsoTimestampSchema = z.string().min(1);
export type IsoTimestamp = z.infer<typeof IsoTimestampSchema>;

/** UUID v4 string. We accept any non-empty string for forward-compat. */
export const UuidSchema = z.string().min(1);
export type Uuid = z.infer<typeof UuidSchema>;

/** Workspace category — top-level tab the v2 UI lives under. */
export const WorkspaceCategorySchema = z.enum([
  "inbox",
  "calendar",
  "finance",
  "docs",
  "technical",
  "work",
]);
export type WorkspaceCategory = z.infer<typeof WorkspaceCategorySchema>;
